import BaseService from '@src/services/BaseService'
import * as storeFile from "@state/store";

class ImportJobService extends BaseService {
    constructor() {
        super('import-jobs')
    }

    getUrl() {
        return `${process.env.VUE_APP_API_ENDPOINT}/${this.filterTenant ? `tenant/${storeFile.default.getters['auth/tenantId']}/` : ''}${this.urlRoute}`
    }

    createCsv(csv) {
        const formData = new FormData()
        formData.append('import_file', csv.file)
        formData.append('import_type', csv.type)
        formData.append('import_delimiter', csv.delimiter)
        for (const key in csv.fields_mapped) {
            formData.append(
                `fields[${key}]`,
                csv.fields_mapped[key] !== null ? csv.fields_mapped[key] : ''
            )
        }
        formData.append('has_headers', csv.has_headers ? 1 : 0)
        formData.append('schedule_for_end_of_day', csv.schedule_for_end_of_day ? 1 : 0)

        if (csv?.questionnaire) {
            formData.append('import_questionnaire', csv.questionnaire.id)
        }

        if (csv.type === 'mix_has_product' || csv.type === 'team') {
            formData.append('import_process_type', csv.process_type)
        }

        return this.axios.post(`${this.getUrl()}/create`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    cancelScheduled(id) {
        return this.axios.post(`${this.getUrl()}/${id}/cancel`)
    }
}

export default new ImportJobService()
